export const getAvailColor = (v) => v >= 20 ? "#16A34A" : v >= 10 ? "#D97706" : "#DC2626";
export const getAvailBg    = (v) => v >= 20 ? "#F0FDF4" : v >= 10 ? "#FFFBEB" : "#FEF2F2";
export const getAvailLabel = (v) => v >= 20 ? "Available" : v >= 10 ? "Partial" : "Busy";
export const getAvailClass = (v) => v >= 20 ? "available" : v >= 10 ? "partial" : "busy";

export default function AvailabilityRing({ value = 0, size = 56 }) {
  const v      = Number(value) || 0;
  const stroke = Math.max(3, Math.round(size * 0.09));
  const r      = (size - stroke * 2) / 2;
  const circ   = 2 * Math.PI * r;
  const filled = (Math.min(v, 40) / 40) * circ;
  const color  = getAvailColor(v);
  const numSize = size > 48 ? Math.round(size * 0.26) : Math.round(size * 0.28);
  const lblSize = Math.max(7, Math.round(size * 0.16));

  return (
    <div style={{ position:"relative", width:size, height:size, flexShrink:0, display:"inline-block" }}>
      <svg width={size} height={size} style={{ transform:"rotate(-90deg)", display:"block" }}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#F3F4F6" strokeWidth={stroke} />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={`${filled} ${circ}`} strokeLinecap="round" />
      </svg>
      <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", lineHeight:1, gap:1 }}>
        <span style={{ fontSize:numSize, fontWeight:900, color, lineHeight:1 }}>{v}</span>
        <span style={{ fontSize:lblSize, fontWeight:600, color, opacity:0.7, lineHeight:1 }}>hrs/wk</span>
      </div>
    </div>
  );
}
